import { ApiClient } from "../common/apiClient";
import { ApiResult } from "../common/apiResult";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api`;

interface AuthResponse {
  token: string;
  expirationDate: Date;
}

export const AuthService = {
  login: async (
    email: string,
    password: string
  ): Promise<ApiResult<AuthResponse>> => {
    try {
      const result = await ApiClient.post<AuthResponse>(`${API_BASE}/auth/login`, {
        email,
        password,
      });
      return { data: result };
    } catch (err: any) {
      return { error: { message: err?.message || "Login failed" } };
    }
  },

  loginWithGoogle: async (
    googleToken: string
  ): Promise<ApiResult<AuthResponse>> => {
    try {
      const result = await ApiClient.post<AuthResponse>(
        `${API_BASE}/auth/google`,
        googleToken
      );
      return { data: result };
    } catch (err: any) {
      return { error: { message: err?.message || "Google login failed" } };
    }
  },

  register: async (
    email: string,
    password: string,
    confirmPassword: string
  ): Promise<ApiResult<void>> => {
    try {
      const result = await ApiClient.post<void>(`${API_BASE}/auth/register`, {
        email,
        password,
        confirmPassword,
      });
      return { data: result };
    } catch (err: any) {
      return { error: { message: err?.message || "Registration failed" } };
    }
  },
};
